import React from "react";

const Consultation = () => {
  return (
    <>
      <section id="consultation_area" className="section_padding_bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="consultation_area_text">
                <h2>Have you any question? Get A Consultation</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Consultation;
